import {
  AfterContentInit,
  Directive,
  ElementRef, EventEmitter,
  Input,
  Output
} from '@angular/core';

@Directive({
    selector: '[appScrollToRow]',
    standalone: false
})
export class ScrollToRowDirective implements AfterContentInit{
  @Input() appScrollToRow;
  @Input() rowId;
  @Output() rowActive:EventEmitter<number>=new EventEmitter<number>();

  constructor(private el: ElementRef) {  }

  ngAfterContentInit(): void {
    setTimeout(() => {
      if (this.appScrollToRow == this.rowId) {
          this.el.nativeElement.scrollIntoView({behavior: 'instant', block: 'center'});
          this.rowActive.emit(this.rowId);
      }
    });
  }
}
